import React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";

const CopyClipboard = (props) => {
  const { dataCopy } = props;
  const [copied, setCopied] = useState(false);

  return (
    <CopyToClipboard text={dataCopy} onCopy={() => setCopied(true)}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ContentCopyIcon />}
      >
        {copied ? "Copied!" : "Copy"}
      </Button>
    </CopyToClipboard>
  );
};

export default CopyClipboard;
